import * as React from 'react';
import useTtdSettings from './useTtdSettings';
import useConversionPixel from './useConversionPixel';

export default function useTrackEmailSignup(): () => void {
    const { emailSignupEventId } = useTtdSettings();
    const renderPixel = useConversionPixel();

    return React.useCallback(() => {
        if (emailSignupEventId) {
            renderPixel({
                ct: emailSignupEventId,
                alt: 'ttd email signup',
            });
        }
    }, [renderPixel, emailSignupEventId]);
}
